import { getLocalStorage, setLocalStorage } from "../../helpers/Utils";
import { GET_CONFIG_SETTINGS, CONFIG_ERROR_GENERATED } from "../types";

const INITIAL_STATE = getLocalStorage("settingData") || {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CONFIG_SETTINGS:
      let oppExpiryDays = action.payload?.oppExpiryDays;
      let educatorAllowedDomain = action.payload?.educatorAllowedDomain;
      let basePort = action.payload?.basePort;
      let logoutIdealTime = action.payload?.logoutIdealTime;
      let sessionPopupDate = action.payload?.sessionPopupDate;
      let maxDayForNotNow = action.payload?.maxDayForNotNow;
      setLocalStorage("settingData", {
        ...state,
        oppExpiryDays,
        educatorAllowedDomain,
        basePort,
        sessionPopupDate,
        logoutIdealTime,
        maxDayForNotNow,
      });
      return {
        ...state,
        oppExpiryDays,
        educatorAllowedDomain,
        basePort,
        sessionPopupDate,
        logoutIdealTime,
        maxDayForNotNow,
      };
    case CONFIG_ERROR_GENERATED:
      let error = action.payload;
      return { ...state, error };
    default:
      return state;
  }
};
